export default __webpack_public_path__ + "static/media/image-section-102-min.5c34d548.png";